import { app } from '@microsoft/teams-js';

import { HostType } from '@tdp/common/host';
import { detectHost } from '@tdp/common/host/hostDetection';
import { SupportedLocale, SupportedLocales } from '@tdp/common/localization';
import { settingsSlice } from '@tdp/common/settings';

import { StartupFunction } from '.';

export const tdpSettingsStartup: StartupFunction = async (root) => {
  const { store, commands, services } = root;
  const { settingsService, logger: baseLogger } = services;
  const logger = baseLogger.extend('tdpSettingsStartup');

  const host = detectHost();

  const adminPromise = settingsService.readUserAdminRole();
  const localePromise =
    host === HostType.TEAMS
      ? app.getContext()
      : settingsService.readUserLocale();

  localePromise.catch((error) => {
    logger.error(
      `Failed to fetch the locale from ${host === HostType.TEAMS ? 'Teams host' : 'UserSettings local network call'}: ${error}`
    );
  });

  const [isAdminResult, localeResult] = await Promise.all([
    adminPromise,
    localePromise,
  ] as const);

  if (isAdminResult.type === 'success') {
    //TODO(nibeauli): stuff this into a setting... somewhere
    store.dispatch(
      settingsSlice.actions.setUserAdminSettings({
        isAdmin: isAdminResult.isAdmin,
      })
    );
  } else {
    logger.error('Failed to read user admin role: [%s]', isAdminResult.error);
  }

  if (isAppContext(localeResult)) {
    if (SupportedLocales.includes(localeResult.app.locale as SupportedLocale)) {
      store.dispatch(
        commands.localeCommands.loadLocaleStrings(
          localeResult.app.locale as SupportedLocale
        )
      );
      store.dispatch(
        commands.localeCommands.updateCurrentLocale(
          localeResult.app.locale as SupportedLocale
        )
      );
    }
  } else {
    if (localeResult.type === 'success') {
      store.dispatch(
        commands.localeCommands.loadLocaleStrings(localeResult.locale)
      );
      store.dispatch(
        commands.localeCommands.updateCurrentLocale(localeResult.locale)
      );
    } else {
      logger.error('Failed to read user locale: [%s]', localeResult.error);
    }
  }
};

function isAppContext(result: any): result is app.Context {
  return result && typeof result === 'object' && 'app' in result;
}
